import React from 'react';
export function TurningPointSection() {
  return <section className="w-full bg-gradient-to-b from-white to-blue-50 py-10 md:py-16 px-6" data-id="element-239">
      <div className="max-w-3xl mx-auto" data-id="element-240">
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#1a1a2e]" data-id="element-241">
          <h2 className="font-black text-3xl md:text-4xl mb-8 text-center" data-id="element-242">
            Imagine a different tonight.
          </h2>

          <p data-id="element-243">
            Imagine saying "Time's up," and having your child look up, smile,
            and walk to the dinner table. No yelling. No crying. Just... peace.
          </p>

          <p data-id="element-244">
            I have spent years studying the Neuro-Biological Loop of digital
            addiction. The reason they scream isn't because they are "bad"—it's
            because their brain is experiencing a chemical crash.
          </p>

          <p className="font-semibold text-xl md:text-2xl pt-4" data-id="element-245">
            You don't need a 4-week parenting course. You need a 90-Second
            Bridge.
          </p>
        </div>
      </div>
    </section>;
}